import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';
import CreateWebhook from './CreateWebhook';
import edit from '../../../assets/images/edit.svg';
import deleteIcon from '../../../assets/images/delete.svg';
import './index.scss';

class NotificationWebhook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            webhook: null,
            createwebhook: false,
            edit: false,
        }
    }
    
    createWebhook = (edit) => {
        this.setState({
            createwebhook: true,
            edit,
        })
    }
    closeWebhook = () => {
        this.setState({
            createwebhook: false,
            edit: false,
        })
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.formresponse.updateWebhook != nextProps.formresponse.updateWebhook && nextProps.formresponse.updateWebhook === false) {
            this.closeWebhook();
        }
    }
    deleteNotificationWebhook = () => {
        const { business, auth } = this.props;
        const business_id = business.id || auth.studio_id;
        this.props.deleteWebHook(business_id);
    }
    render() {
        const { webhook, updateWebHookFunction, formresponse } = this.props;
        console.log('edit', this.state.edit)
        return (
            <div className="notification-webhook">
                {(formresponse?.updateWebhook || formresponse?.deleteWebhook) ?
                    (<Skeleton height={110} />) :
                    (<>
                        {!webhook?.webhook_url ? <div className="notification-webhook_create-container">
                            <div className="notification-webhook_create-container_title">
                                You don’t have a notification webhook
                            </div>
                            <button className="notification-webhook_create-container_create" onClick={()=>this.createWebhook(false)}>+ Add webhook</button>
                        </div> :
                            <div className="notification-webhook_create-container">
                                <div className="notification-webhook_create-container_title">
                                    {webhook?.webhook_url}
                                </div>
                                <button className="notification-webhook_create-container_edit">
                                    <img src={edit} onClick={() => this.createWebhook(true)} />
                                    <img src={deleteIcon} onClick={this.deleteNotificationWebhook} />
                                </button>
                            </div>
                        }</>)
                }
                <div className="notification-webhook_guidelines">
                    <div className="notification-webhook_guidelines_header">
                        What is notification webhook?
                    </div>
                    <p className="notification-webhook_guidelines_body">
                        TrueLark Lead Engage users have the option to receive information regarding specific Lead Engage events via a webhook.
                    </p>
                    <p className="notification-webhook_guidelines_body">
                        Data the TrueLark will send via webhook: campaign_name, campaign_ID, lead_name, lead_phone_number, lead_email_address,
                        lead_submission_time, promo_service_name, campaign_outcome (Booked On TrueLark, Booked off-platform, Engaged but did
                        not book, Unresponsive, Opted-out), conversation_URL
                    </p>
                    <div className="notification-webhook_guidelines_header">
                        What can I do with this webhook?
                    </div>
                    <ul className="notification-webhook_guidelines_body list">
                        <li>
                            CRM integration: Integrate TrueLark Lead Engage with a CRM to initiate a post-Lead Engage campaign follow-up process.
                        </li>
                        <li>
                            Reporting: Send lead outcome data to Google Sheets to track performance, have staff follow-up with hot leads, etc.
                        </li>
                    </ul>
                    <p className="notification-webhook_guidelines_footer">
                        For more info on what you need for setup visit our{' '}
                        <a href="#/app/help/TrueLark%20-%20Help%20Center%2059e8ab0007ad4658987597990a80a797/Lead%20Engage%20Outcome%20Notifications%20Webhook%20f8d2cea35b624e13b3521a48c1321822.html" target='_blank' className="notification-webhook_guidelines_footer_link">
                            webhook setup guide
                        </a>.
                    </p>
                </div>
                <CreateWebhook modelopen={this.state.createwebhook} edit={this.state.edit} closeModel={this.closeWebhook} updateWebHookFunction={updateWebHookFunction} isLoading={formresponse?.updateWebhook} {...this.props} />
            </div>
        );
    }
}

export default NotificationWebhook;
